// extracted by mini-css-extract-plugin
export default {"innerWrapper":"NE-z","tooltipWrapper":"OE-z","icon":"PE-z","tooltip":"QE-z","content":"RE-z"};